import {
  LOCAL_CONTACT_OPTIONS,
  PROPERTY_MANAGEMENT_OPTIONS,
} from 'src/components/payment/constants';
import { RentalStructure } from './configuration';
import { Person } from './person';

export enum FLOW_DIRECTION {
  BACK,
  FORWARD,
}

export interface RenewState {
  applicationData?: ApplicationData;
  applicationNumber: string;
  documentUploadCompleted: boolean;
  documentUploadErrors: Array<string>;
  documentUploadStarted: boolean;
  documentUploadWorking: boolean;
  fee?: number;
  initiatingRenewFlow: boolean;
  initiatingRenewFlowError: string;
  lateRenewalData: unknown; // if populated should have properties of hasExpired, expirationDate and renewBy (used on confirmation page f there are late fees)
  renewLicenseError: string;
  renewLicenseInProgress: boolean;
  selectedBulkRenewalLicenses: Array<unknown>;
}

export interface Certification {
  signatory: string;
}

export interface DocumentObject {
  required: boolean;
  attachedFiles: Array<{ blobFile: File }>;
}
export type Document = Record<string, DocumentObject>;

export interface ContactsState {
  propertyManager?: Person;
  localContact?: Person;
  selectedManagementOption: PROPERTY_MANAGEMENT_OPTIONS;
  selectedOwnerRepOption: LOCAL_CONTACT_OPTIONS;
}

export interface PropertyDetails extends Record<string, unknown> {
  supplementalQuestions?: Record<string, unknown>;
}

export interface ApplicationData {
  certifications?: Certification;
  contacts?: ContactsState;
  documents?: Document;
  listings?: Array<unknown>;
  property?: Property;
  propertyDetails?: PropertyDetails;
  registrant?: Registrant;
}

export interface Property {
  propertyaddress: string;
  propertyid: string;
  unitnumber: string;
  rentalstructure: RentalStructure;
  isResidential: boolean;
}
export interface Registrant {
  registrantType: RegistrationOptions;
  owner: Array<Person>;
  registrant: unknown;
}

export enum REGISTRANT_OPTIONS {
  OWNER = 'owner',
  PROPERTY_MANAGER = 'propertyManager',
  TENANT = 'tenant',
}

export enum RegistrantType {
  INDIVIDUAL = 'individual',
  BUSINESS = 'business',
  PROPERTY_MANAGER = 'property_manager',
  PROPERTY_OWNER = 'property_owner',
}

export interface UploadConfiguration {
  document: string;
  uploadToken: string;
  files: DocumentObject;
}
